import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";

const RowCategoryActionsMenu = ({ row, onEdit, onDelete, onCreateType, onViewTypes }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton onClick={handleOpen} size="medium">
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onEdit && onEdit(row);
            handleClose();
          }}
        >
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {
            onDelete && onDelete(row.activity_category_id);
            handleClose();
          }}
        >
          Delete
        </MenuItem>

        <MenuItem
          onClick={() => {
            onCreateType && onCreateType(row);
            handleClose();
          }}
        >
          Create Activity Type
        </MenuItem>

        <MenuItem
          onClick={() => {
            onViewTypes && onViewTypes(row);
            handleClose();
          }}
        >
          View Activity Types
        </MenuItem>

        {/* Only show Edit, Delete, and View Activity Types */}
      </Menu>
    </>
  );
};

RowCategoryActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onCreateType: PropTypes.func,
  onViewTypes: PropTypes.func,
};

export default RowCategoryActionsMenu;
